import React from 'react';
import {
  Row, Col, Card, CardHeader, CardBody, Alert,
} from 'reactstrap';
import PropTypes from 'prop-types';
import FormCompany from './FormCompany';
import FormEstate from './FormEstate';
import FormDocuments from './FormDocuments';


const Informations = (props) => {
  const { data, isViewOnly } = props;
  const { category, subcategory } = data;

    return (
      <Row>
        <Col xl="6">
          <form className="form bigger-input">
            <Card className="light-border mt-20 pb-0">
              <CardHeader className="white-background fs16 d-flex align-items-center h-space-between">
                <h4 className="bold-text">Générales</h4>
              </CardHeader>
              <CardBody>
                {
                  category === 'company' || subcategory === 'sci' ? (
                    <FormCompany {...props} />
                  ) : (
                    <FormEstate {...props} />
                  )
                }
              </CardBody>
            </Card>
          </form>
        </Col>
        <Col xl="6">
          <form className="form bigger-input">
            <Card className="light-border mt-20 pb-0">
              <CardHeader className="white-background fs16 d-flex align-items-center h-space-between">
                <h4 className="bold-text">Documents administratifs</h4>
              </CardHeader>
              <CardBody>
                <FormDocuments {...props} />
              </CardBody>
            </Card>
          </form>
          {
            !isViewOnly && (
              <Alert color="info" className="mt-20">
                <b>Rappel</b> : l'intégralité de vos données et documents est sécurisée et chiffrée, et ne reste accessible que par vous et vos destinataires de l'information désignés selon les permissions définies.
              </Alert>
            )
          }
        </Col>
      </Row>
    );
};

Informations.propTypes = {
  data: PropTypes.shape({}).isRequired,
  isViewOnly: PropTypes.bool.isRequired,
};

export default Informations;
